import { identity } from 'lodash';
import { getLayoutName } from '../layout-types';
// Post design params
export const IS_MOBILE_DESIGN_SETTINGS_ENABLED = 'blog-mobile-isMobileDesignSettingsEnabled';
export const IS_MOBILE_DESIGN_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_DESIGN_SETTINGS_ENABLED}`;
const TITLE_FONT_SIZE = 'titleFontSize';
const DESCRIPTION_FONT_SIZE = 'descriptionFontSize';
export const IS_FEED_DESIGN_PROPS_MIGRATED = 'blog-isFeedDesignPropsMigrated';
export const IS_FEED_DESIGN_PROPS_MIGRATED_PATH = `style.booleans.${IS_FEED_DESIGN_PROPS_MIGRATED}`;
export const IS_CONFIGURABLE_LINE_CLAMPING_ENABLED = 'blog-isConfigurableLineClampingEnabled';
export const IS_CONFIGURABLE_LINE_CLAMPING_ENABLED_PATH = `style.booleans.${IS_CONFIGURABLE_LINE_CLAMPING_ENABLED}`;
export const POST_TITLE_COLOR = 'post-titleColor';
export const POST_TEXT_COLOR = 'post-textColor';
export const POST_TITLE_FONT = 'post-titleFont';
export const POST_DESCRIPTION_FONT = 'post-descriptionFont';
export const POST_PAGE_FONT = 'post-pageFont';
export const POST_PAGE_FONT_PATH = `style.fonts.${POST_PAGE_FONT}`;
const POST_TITLE_FONT_SIZE_MOBILE = `post-mobile-${TITLE_FONT_SIZE}`;
export const POST_TITLE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_TITLE_FONT_SIZE_MOBILE}`;
const POST_PAGE_FONT_SIZE_MOBILE = 'post-mobile-pageFontSize';
export const POST_PAGE_FONT_SIZE_MOBILE_PATH = `style.numbers.${POST_PAGE_FONT_SIZE_MOBILE}`;
export const getPostLayoutParamByName = (...params) => `post-${params.filter(identity).join('-')}`;
export const getPostLayoutParamByType = (layoutType, section, param, isMobile = false) => getPostLayoutParamByName(getLayoutName(layoutType), section, isMobile ? 'mobile' : '', param);
export const getPostTitleFontSize = (layout, section, isMobile) => getPostLayoutParamByType(layout, section, TITLE_FONT_SIZE, isMobile);
export const getPostDescriptionFontSize = (layout, section, isMobile) => getPostLayoutParamByType(layout, section, DESCRIPTION_FONT_SIZE, isMobile);
export const getPostFontSizesPath = (...args) => `style.numbers.${getPostLayoutParamByType(...args)}`;
export const getGenericPostFontPath = (section, font) => `style.fonts.${getPostLayoutParamByName(section, font)}`;
export const getCardBorderWidth = (layout, section) => `post-${getLayoutName(layout)}-${section}-cardBorderWidth`;
export const getCardBorderWidthPath = (...args) => `style.numbers.${getCardBorderWidth(...args)}`;
export const getFeedBorderColor = (section) => `post-${section}-borderColor`;
export const getFeedBorderColorPath = (section) => `style.colors.${getFeedBorderColor(section)}`;
export const getMobileFeedBorderColor = (section) => `post-${section}-mobile-borderColor`;
export const getMobileFeedBorderColorPath = (section) => `style.colors.${getMobileFeedBorderColor(section)}`;
export const CARD_BACKGROUND_COLOR = 'post-cardBackgroundColor';
export const CARD_BORDER_COLOR = 'post-cardBorderColor';
export const CARD_BORDER_WIDTH = 'post-cardBorderWidth';
export const CARD_BORDER_WIDTH_PATH = `style.numbers.${CARD_BORDER_WIDTH}`;
export const APP_BACKGROUND_COLOR = 'post-appBackgroundColor';
export const APP_BACKGROUND_CATEGORY_COLOR = 'post-appBackgroundCategoryColor';
export const BUTTON_COLOR = 'button-color';
export const LINK_AND_HASHTAG_COLOR = 'blog-linkHashtagColor';
//# sourceMappingURL=post.wix-params.js.map